module.exports = __webpack_public_path__ + "img/icon_chat_send.033fd46a.png";